module.exports = __webpack_public_path__ + "img/20210728085725682qqm.52b9aba0.png";